import { Carousel as CarouselOriginal } from "@mantine/carousel";
import "@mantine/carousel/styles.css";
import css from "./Carousel.module.css";

export const Carousel: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <CarouselOriginal
      withIndicators={true}
      mx="auto"
      align="start"
      classNames={css}
    >
      {children}
    </CarouselOriginal>
  );
};
